import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LogoMark } from "./LogoMark";

const links = [
  { label: "Overview", href: "#overview" },
  { label: "Features", href: "#features" },
  { label: "Versions", href: "#versions" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = ({ onNotify }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "glass-panel border-x-0 border-t-0" : "border-b border-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-brand-link">
          <LogoMark size={34} />
          <span className="font-serif-display text-xl tracking-tight text-slate-50">Neyrein</span>
        </a>
        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-slate-400 transition-colors duration-300 hover:text-sky-300"
            >
              {l.label}
            </a>
          ))}
        </div>
        <button
          data-testid="nav-get-app-btn"
          onClick={() => onNotify("Neyrein is almost here", "Mobile and desktop builds are in final polish. Downloads open soon.")}
          className="rounded-full border border-sky-400/30 bg-sky-400/10 px-5 py-2 text-sm font-medium text-sky-300 transition-all duration-300 hover:border-sky-400/60 hover:bg-sky-400/20 hover:shadow-[0_0_24px_rgba(56,189,248,0.35)]"
        >
          Get the app
        </button>
      </nav>
    </motion.header>
  );
};
